import { HAKLAI_ANOTHER_QUESTIONS_ERRORS } from "./haklaiAnotherQuestionsTexts";

export const validateHaklaiAnotherQuestions = (calc) => {
  const mainCalc = calc?.mainCalc || {};
  if (mainCalc.isGilum && mainCalc.prisa?.shouldTryPrisa) {
    return HAKLAI_ANOTHER_QUESTIONS_ERRORS.prisaAndGrossUpConflict;
  }
  return null;
};
